import React, { FC } from "react";

interface ReturningFlightProps {
  className: string;
}

const ReturningFlight: FC<ReturningFlightProps> = ({ className }) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" color="#66797F" width="24" height="24" className={className}><path d="M9 20.25H22.5" stroke="#66797F" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.25 8.72458V4.79053C2.25 4.67169 2.27824 4.55455 2.33239 4.44877C2.38655 4.34298 2.46506 4.25158 2.56147 4.1821C2.65787 4.11261 2.76941 4.06703 2.88689 4.04911C3.00437 4.03118 3.12443 4.04143 3.23717 4.07902L4.5 4.49996L6 7.31246L9 8.24996V4.79053C9 4.67169 9.02824 4.55455 9.08239 4.44877C9.13655 4.34298 9.21506 4.25158 9.31147 4.1821C9.40787 4.11261 9.51941 4.06703 9.63689 4.04911C9.75437 4.03118 9.87443 4.04143 9.98717 4.07902L11.25 4.49996L14.25 9.74996L18.8029 11.0147C19.4347 11.1902 19.9916 11.5678 20.3884 12.0898C20.7852 12.6119 21 13.2495 21 13.9052V14.9315C21 15.5937 20.368 16.073 19.7304 15.8945L4.44111 11.6135C3.81071 11.437 3.25535 11.0591 2.85974 10.5375C2.46414 10.0159 2.25 9.37922 2.25 8.72458Z" stroke="#66797F" stroke-linecap="round" stroke-linejoin="round"></path></svg>



  );
};

export default ReturningFlight;


